const CARD_LINKED_OFFERS_SERVER_ERROR_MSG = 'card-linked-offers-server-error';
const CC_PREQUAL_SERVICE_ERROR_MSG = 'cc-prequal-service-error';
const MARKETPLACE_INVALID_TOKEN_MSG = 'Marketplace token is invalid';
const MARKETPLACE_SERVER_ERROR_MSG = 'marketplace-server-error';
const NOTFOUND_ERROR_MSG = 'product-not-found';
const OVERRIDE_LINK_MALFORMED_MSG = 'Malformed override link';
const OVERRIDE_LINK_NOT_WHITELISTED_MSG =
  'Override link did not match any patterns';
const PREQUAL_ISSUER_NOTFOUND_ERROR_MSG = 'prequal-issuer-not-found';
const REDIRECT_SERVICE_ERROR_MSG = 'redirect-service-error';

class OverrideError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

export {
  CARD_LINKED_OFFERS_SERVER_ERROR_MSG,
  CC_PREQUAL_SERVICE_ERROR_MSG,
  MARKETPLACE_INVALID_TOKEN_MSG,
  MARKETPLACE_SERVER_ERROR_MSG,
  NOTFOUND_ERROR_MSG,
  OVERRIDE_LINK_MALFORMED_MSG,
  OVERRIDE_LINK_NOT_WHITELISTED_MSG,
  OverrideError,
  PREQUAL_ISSUER_NOTFOUND_ERROR_MSG,
  REDIRECT_SERVICE_ERROR_MSG,
};
